import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const LoadingFallback = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        const newProgress = oldProgress + Math.random() * 10;
        return newProgress >= 100 ? 100 : newProgress;
      });
    }, 500); // Simula um progresso gradual

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      className="flex flex-col justify-center items-center h-64 w-full"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <motion.div
        className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1 }}
      />
      <motion.p
        className="mt-4 text-blue-500 font-semibold text-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        Carregando...
      </motion.p>
      <div className="w-64 h-3 bg-gray-300 rounded-full overflow-hidden mt-4">
        <motion.div
          className="h-full bg-blue-500 rounded-full"
          initial={{ width: "0%" }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
};

export default LoadingFallback;